import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import theme from '../../theme';
import { LoadingSlugs } from '@codametrix/ui-components';
import deepEqual from 'deep-equal';
import React from 'react';
import { LOAD_STATES } from '../../reducers/common';
import UpdatePasswordForm from '../password-change/password-change-form';
class ResetPassword extends React.Component {
    componentDidMount() {
        const token = new URL(window.location.href).searchParams.get('token') || '';
        const expiry = new URL(window.location.href).searchParams.get('expiry') || '';
        const firstName = new URL(window.location.href).searchParams.get('firstName') || '';
        const lastName = new URL(window.location.href).searchParams.get('lastName') || '';
        const username = new URL(window.location.href).searchParams.get('username') || '';
        const passwordDto = {
            token,
            expiry: parseInt(expiry),
            firstName,
            lastName,
            username,
            userId: '',
            id: null
        };
        this.props.savePasswordResetParameters(passwordDto);
    }
    render() {
        const { passwordResetDto, save, handleNavigateHome, loadState, formErrors, isValidToken } = this.props;
        const handleSubmit = (newPassword)=>{
            save({
                ...passwordResetDto,
                password: newPassword.newPassword,
                confirmPassword: newPassword.newPasswordConfirm
            });
        };
        const isLoading = deepEqual(loadState, LOAD_STATES.started);
        let inner;
        if (deepEqual(loadState, LOAD_STATES.done)) {
            inner = /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("h5", {
                        children: "Password Reset Success"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: "Please return to the login page and enter your new credentials."
                    }),
                    ' ',
                    /*#__PURE__*/ _jsx(Button, {
                        size: ButtonSize.MD,
                        label: 'Return',
                        backgroundColor: theme.colors.accent[100],
                        color: theme.colors.text['light'],
                        name: "Return",
                        dataTestId: "returnResetPass",
                        onClick: handleNavigateHome
                    })
                ]
            });
        } else if (deepEqual(loadState, LOAD_STATES.started) && isValidToken === false) {
            inner = /*#__PURE__*/ _jsx(LoadingSlugs, {
                numberItems: 5
            });
        } else if (loadState.error === true && isValidToken === false) {
            inner = /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "error-msg",
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "fa fa-times-circle"
                            }),
                            " ",
                            this.props.formErrors.fieldErrors.confirmPassword
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: "Your password recovery email may also no longer be valid. Please try again or contact a CodaMetrix administrator for further assistance."
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: ButtonSize.MD,
                        label: 'Return',
                        backgroundColor: theme.colors.accent[100],
                        color: theme.colors.text['light'],
                        name: "Return",
                        dataTestId: "returnResetPass",
                        onClick: handleNavigateHome
                    })
                ]
            });
        } else {
            inner = /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("h5", {
                        children: [
                            "Welcome back ",
                            passwordResetDto.firstName,
                            ' ',
                            passwordResetDto.lastName
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            "You have requested to reset your password. ",
                            /*#__PURE__*/ _jsx("br", {}),
                            "Please enter and confirm your new password below."
                        ]
                    }),
                    /*#__PURE__*/ _jsx(UpdatePasswordForm, {
                        ...this.props,
                        handleNewPassword: handleSubmit,
                        handleContinue: ()=>{},
                        submitting: isLoading,
                        error: formErrors.status !== ''
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: 'reset-password-form qa-reset-password-form',
            children: inner
        });
    }
}
export default ResetPassword;
